export default "__VITE_ASSET__AUaeizt9__"